
// 成本核算
import TableList from "@components/templates/tablelist";
import { HttpSettlementList, HttpBatchSettlement, HttpBatchRevoke, HttpDaySettlement, HttpNoSettlement, HttpBatchRevokeAll } from "@/service/fedex";
import { mapGetters } from "vuex";
import comExcel from '@components/templates/excelalert'
import recount from './recount'
// import mixin from "../mixin";
export default {
    mixins: [TableList],
    components: {
        comExcel,
        recount
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {},
            Searchs: {
                show: true,
                labelWidth: 110,
            },
            Plugins: { show: true }
        };
    },
    methods: {
        ajaxRequest: HttpSettlementList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
            }
            switch (type) {
                case "query":
                    var url = this.$router.resolve({
                        name: "fedexUpdateSettlement",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "edit":
                    this.$router.push({
                        name: 'fedexUpdateSettlement',
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;
                case 'redetail':
                    this.operate = {
                        show: true,
                        alert: "primary",
                        params: { ids: params },
                        title: this.$t('fbb.settlement.redetail',{defaultValue:'结算'}),
                        ajaxRequest: HttpBatchSettlement
                    };
                    break;
                case 'unredetail':
                    this.operate = {
                        show: true,
                        alert: "error",
                        params: { ids: params },
                        title: this.$t('fbb.settlement.unredetail',{defaultValue:'撤销结算'}),
                        ajaxRequest: HttpBatchRevoke
                    };
                    break;
                case 'batchunredetail':
                    // 批量撤销
                    this.operate = {
                        show: true,
                        alert: "error",
                        width:460,
                        title: this.$t('fbb.settlement.unredetail',{defaultValue:'撤销结算'}),
                        formdata:[
                            {
                                label: this.$t('fbb.bill.organization',{defaultValue:'组织'}),
                                tag: 'vSelect',
                                key: 'orgId',
                                options: this.getBillcusorgList,
                                props: {
                                    filterable: true,
                                },
                                span:24,
                            },
                            {
                                label: this.$t('fbb.bill.task_number',{defaultValue:'任务编号'}),
                                key: "taskNo",
                                span:24
                            },
                        ],
                        ajaxRequest: HttpBatchRevokeAll
                    };
                    break;
                case "repeal":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('fbb.settlement.batch_unredetail',{defaultValue:'批量撤销结算'}),
                        ajaxRequest: HttpBatchRevoke
                    };
                    break;
                case 'dayaccount':
                    this.operate = {
                        show: true,
                        alert: "info",
                        title: this.$t('fbb.settlement.dateaccount',{defaultValue:'按日期结算'}),
                        showDesc:false,
                        formdata: [
                            {
                                tag: "vDatepicker",
                                key: "startDay",
                                labelWidth:0,
                                span:24,
                                props: {
                                    style:'width:100%',
                                    format: 'yy-mm-dd ~ yy-mm-dd',
                                    confirm: false,
                                    placeholder: this.$t('global.common.choose',{defaultValue:'请选择日期'})
                                },
                                required:false,
                            }
                        ],
                        ajaxRequest: HttpDaySettlement,
                        interceptRequest(data){
                            const search = data.startDay, startDayarray = (search||"").split('~'),json = {};
                            json.startDay = startDayarray[0];
                            json.endDay = startDayarray[1]
                            return json
                        }
                    };
                    break;
                case 'noaccount':
                    this.operate = {
                        show: true,
                        alert: "warning",
                        params: { ids: params },
                        title: this.$t('fbb.settlement.noaccount',{defaultValue:'无需结算'}),
                        ajaxRequest: HttpNoSettlement
                    };
                    break;
                    case 'recount':
                        this.operate = {
                            title: this.$t('fbb.settlement.recount',{defaultValue:'重新结算（附加费）'}),
                            show: true,
                            width: 500,
                            component: "recount",
                            showFooter: false
                        }
                        break;
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/freightSettlement/export', this.formData, {
                        executor:'request',
                        download:true,
                        method:'get',
                    }).then(res => {
                        this.operate = {
                            title: this.$t('global.common.export', { defaultValue: '导出' }),
                            show: true,
                            width: 560,
                            component: "comExcel",
                            showFooter: false
                        }
                    })
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id, status } = row
            return [{
                label: this.$t('fbb.alloment.query_detail',{defaultValue:'查看详情'}),
                show: true,
                params: id,
                operate: 'query'
            },
            // case "SETTLEMENT_ERROR": return <div class="color-error">结算异常</div>; break;
            //             case "PROCESSED": r
            {
                label: this.$t('global.common.edit',{defaultValue:'编辑'}),
                show: status == 'PROCESSED' || status == 'SETTLEMENTED' || status == 'SETTLEMENT_ERROR',
                params: id,
                operate: 'edit'
            },
            {
                label: this.$t('fbb.settlement.redetail',{defaultValue:'结算'}),
                show: status == 'PROCESSED' || status == 'SETTLEMENT_ERROR',
                params: id,
                operate: 'redetail'
            },
            {
                label: this.$t('fbb.settlement.unredetail',{defaultValue:'撤销结算'}),
                show: status == 'SETTLEMENTED',
                params: id,
                operate: 'unredetail'
            }
            ]
        }
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getBillcusWareList', 'getCusproductList','getCarrierServiceList','getAlllogProCodeList', 'getCarrierServiceAllList', 'getCustomServiceAllList']),
        ToolsData() {
            return [
                {
                    name: this.$t('fbb.settlement.batch_redetail',{defaultValue:'批量结算'}),
                    operate: "redetail",
                    theme: "primary",
                    batch:true,
                },
                {
                    name: this.$t('global.common.export',{defaultValue:'导出'}),
                    operate: "export",
                    theme: "primary",
                },
                // {
                //     name: this.$t('fbb.settlement.batch_unredetail',{defaultValue:'批量撤销结算'}),
                //     operate: "repeal",
                //     batch:true,
                //     more:true,
                // },
                // {
                //     name: this.$t('fbb.settlement.dateaccount',{defaultValue:'按日期结算'}),
                //     operate: "dayaccount",
                //     more:true,
                // },
                {
                    name: this.$t('fbb.settlement.noaccount',{defaultValue:'无需结算'}),
                    operate: "noaccount",
                    batch:true,
                    more:true,
                },
                {
                    name: this.$t('fbb.settlement.unredetail',{defaultValue:'撤销结算'}),
                    operate: "batchunredetail",
                    more:true,
                },
                {
                    name: this.$t('fbb.settlement.recount',{defaultValue:'重新结算（附加费）'}),
                    operate: "recount",
                    more:true,
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: "Tracking NO",
                    tag: 'vInput',
                    key: 'EQ_trackingNo',
                    show: true,
                },
                {
                    label: this.$t('erp.b2border.invoice',{defaultValue:'发票号'}),
                    tag: 'vInput',
                    key: 'EQ_invoiceNo',
                    show: true,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('fbb.bill.freeze_createdat',{defaultValue:'创建日期'}),
                    tag: 'vDatepicker',
                    style: "width:250px",
                    key: 'BT_createdAt',
                    default: this.handleDateRange().join(' ~ '),
                    show: true,
                    props: {
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                },
                {
                    label: this.$t('fbb.bill.source_system',{defaultValue:'来源系统'}),
                    tag: 'vSelect',
                    key: 'EQ_sourceSystem',
                    more: true,
                    options: [
                        {value:'fbb',label:this.$t('fbb.bill.cloud_warehouse',{defaultValue:'云仓'})},
                        {value:'bizarkCloudShipping',label:'Bizark Cloud Shipping'},
                        {value:'UN_KNOW',label:this.$t('fbb.bill.unknown',{defaultValue:'未知'})},
                    ],
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('global.common.organization',{defaultValue:'组织'}),
                    tag: 'vSelect',
                    key: 'EQ_orgId',
                    more: true,
                    options: this.getBillcusorgList,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('global.common.project',{defaultValue:'项目'}),
                    tag: 'vSelect',
                    key: 'EQ_lineId',
                    more: true,
                    options: this.getCusproductList,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label:this.$t('erp.b2c.product_orgwarehouse',{defaultValue:'仓库'}) ,
                    tag: 'vSelect',
                    key: 'EQ_orgWarehouseCode',
                    options: this.getBillcusWareList.map(item=>{
                        return {
                            value: item.attach.code,
                            label: item.label
                        }
                    }),
                    props: {
                        filterable: true,
                    }
                },
                {
                    // label: this.$t('fbb.alloment.carrier_server',{defaultValue:'物流产品服务'}),
                    label: this.$t('fbb.bill.service_code',{defaultValue:'承运商服务'}),
                    tag: 'vSelect',
                    key: 'EQ_carrierServiceCode',
                    more: true,
                    options: this.getCarrierServiceAllList.map(item=>{
                        return {
                            value: item.attach.carrierServiceCode,
                            label:item.label
                        }
                    }),
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('fbb.bill.logistics_products',{defaultValue:'物流产品'}),
                    // label: "物流产品",
                    tag: 'vSelect',
                    key: 'EQ_groupName',
                    more: true,
                    // options: [
                    //     {value:'FedEx',label:'FedEx'},
                    //     {value:'UPS',label:'UPS'},
                    // ],
                    options: this.getCustomServiceAllList.map(item=>{
                        return {
                            value:item.label,
                            label:item.label
                        }
                    }),
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('global.common.status',{defaultValue:'状态'}),
                    tag: 'vSelect',
                    key: 'EQ_status',
                    more: true,
                    options: [
                        {value:'SETTLEMENTED', label: this.$t('fbb.costmanage.caculated',{defaultValue:'已结算'})},
                        {value:'SETTLEMENT_ERROR', label:this.$t('fbb.costmanage.caculate_error',{defaultValue:'结算异常'}) },
                        {value:'PROCESSED', label:this.$t('fbb.costmanage.processed',{defaultValue:'待处理'})},
                        {value:'NOSETTLEMENT', label:this.$t('fbb.settlement.noaccount',{defaultValue:'无需结算'})},

                    ],
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('erp.b2c.search_errorcode',{defaultValue:'异常类型'}),
                    tag: 'vSelect',
                    key: 'EQ_errorStatus',
                    more: true,
                    options: [
                        {value:'RESTRICT_RULE_ERROR', label:this.$t('fbb.settlement.rule_error',{defaultValue:'限制规则异常'})},
                        {value:'ZONE_ERROR', label:this.$t('fbb.settlement.zone_error',{defaultValue:'分区异常'})},
                        {value:'BASIC_RATE_ERROR', label:this.$t('fbb.settlement.base_error',{defaultValue:'基础费率异常'})},
                        {value:'CUSTOMER_DISCOUNT_ERROR', label:this.$t('fbb.settlement.cusdiscount_error',{defaultValue:'客户折扣率异常'})},
                        {value:'CARRIER_ERROR', label:this.$t('fbb.settlement.carrier_error',{defaultValue:'承运商异常'})},
                        {value:'OTHER_ERROR', label:this.$t('fbb.settlement.other_error',{defaultValue:'其他异常'})},
                    ],
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('fbb.costmanage.exception_tip',{defaultValue:'异常说明'}),
                    tag: 'vInput',
                    key: 'CN_errorMessage',
                    more: true,
                },
                {
                    label: this.$t('fbb.adjustment.list_sourceno',{defaultValue:'关联单号'}),
                    tag: 'vInput',
                    key: 'EQ_sourceNo',
                    more: true,
                },
                {
                    label: this.$t('fbb.adjustment.total_originalbill',{defaultValue:'原始账单总额'}),
                    tag: 'vInput',
                    key: 'EQ_totalOriginalCost',
                    more: true,
                },
            ]
        },

        columns() {
            return [
            {
                type: 'selection',
                width: 40,
                align: 'center',
                formName: 'id'
            },
            {
                title: this.$t('global.common.actions',{defaultValue:'操作'}),
                maxWidth: 90,
                render: this.getOperateNodes
            },
            {
                title: 'Tracking NO',
                key: 'trackingNo',
            },
            {
                title: this.$t('fbb.adjustment.total_originalbill',{defaultValue:'原始账单总额'}),
                key: 'totalOriginalCost',
            },
            {
                title: this.$t('global.common.organization',{defaultValue:'组织'})+'/'+this.$t('global.common.warehouse',{defaultValue:'仓库'})+'/'+this.$t('global.common.project',{defaultValue:'项目'}),
                width:150,
                render: (h, { row }) => {
                    let orgWarehouseCode = row.orgWarehouseCode
                    let orgWarehouse = this.getBillcusWareList.find(item=>{
                        // console.log(item)
                        return item.attach.code == orgWarehouseCode
                    })
                    return <div>
                        <div>{row.orgName}</div>
                        {orgWarehouse ? orgWarehouse.label : '--'}
                        <div>{row.lineName || '--'}</div>
                    </div>
                }
            },
            {
                title: '来源系统',
                render:(h,{row})=>{
                    switch(row.sourceSystem){
                        case 'fbb': return this.$t('global.common.fbb',{defaultValue:'云仓'}); break;
                        case 'UN_KNOW': return '未知'; break;
                        default: return 'Bizark Cloud Shipping'; break;

                    }
                }
            },
            {
                title: this.$t('global.common.status',{defaultValue:'状态'}),
                render: (h, { row }) => {
                    switch (row.status) {
                        case "SETTLEMENTED": return <div class="color-success">{this.$t('fbb.costmanage.caculated',{defaultValue:'已结算'})}</div>; break;
                        case "SETTLEMENT_ERROR": return <div class="color-error">{this.$t('fbb.costmanage.caculate_error',{defaultValue:'结算异常'})}</div>; break;
                        case "PROCESSED": return <div class="color-warning">{this.$t('fbb.costmanage.processed',{defaultValue:'待处理'})}</div>; break;
                        case "NOSETTLEMENT": return <div class="color-info">{this.$t('fbb.settlement.noaccount',{defaultValue:'无需结算'})}</div>; break;
                    }
                },
                width:80,
            },
            {
                // title: this.$t('fbb.alloment.carrier_server',{defaultValue:'物流产品服务'})+'/'+this.$t('fbb.settlement.zoneCode',{defaultValue:'分区代码'}),
                title: this.$t('fbb.bill.service_code',{defaultValue:'承运商服务'})+'/'+this.$t('fbb.settlement.zoneCode',{defaultValue:'分区代码'}),
                width:160,
                render:(h,{row})=>{
                    return <div>
                        <div>{row.carrierServiceCode || '--'}</div>
                        <div>{row.zoneCode || '--'}</div>
                    </div>
                }
            },
            {
                title: this.$t('fbb.bill.logistics_products',{defaultValue:'物流产品'}),
                // title: "物流产品",
                key: 'groupName',
            },
            {
                title: this.$t('erp.b2c.parcel_information',{defaultValue:'包裹信息'}),
                render: (h, { row }) => {
                    return <div>
                        <div>{this.$t('global.common.length',{defaultValue:'长'})}：{row.length} {row.sizeUnit}</div>
                        <div>{this.$t('global.common.width',{defaultValue:'宽'})}：{row.width} {row.sizeUnit}</div>
                        <div>{this.$t('global.common.height',{defaultValue:'高'})}：{row.height} {row.sizeUnit}</div>
                        <div>{this.$t('global.common.weight',{defaultValue:'重量'})}：{row.weight} {row.weightUnit}</div>
                    </div>
                }
            },
            {
                title: this.$t('erp.b2border.invoice',{defaultValue:'发票号'})+'/'+this.$t('fbb.adjustment.list_sourceno',{defaultValue:'关联单号'}),
                width:120,
                render: (h, { row }) => {
                    return <div>
                        <div>{row.invoiceNo|| '--'}</div>
                        <div>{row.sourceNo|| '--'}</div>
                    </div>
                }
            },
            {
                title: this.$t('erp.b2c.search_errorcode',{defaultValue:'异常类型'})+'/'+this.$t('fbb.costmanage.exception_tip',{defaultValue:'异常说明'}),
                width:120,
                render: (h, { row }) => {
                    let errortype;
                    switch (row.errorStatus) {
                        case "RESTRICT_RULE_ERROR": errortype = this.$t('fbb.settlement.rule_error',{defaultValue:'限制规则异常'}); break;
                        case "ZONE_ERROR": errortype = this.$t('fbb.settlement.zone_error',{defaultValue:'分区异常'}); break;
                        case "BASIC_RATE_ERROR": errortype = this.$t('fbb.settlement.base_error',{defaultValue:'基础费率异常'}); break;
                        case "CUSTOMER_DISCOUNT_ERROR": errortype = this.$t('fbb.settlement.cusdiscount_error',{defaultValue:'客户折扣率异常'}); break;
                        case "CARRIER_ERROR": errortype = this.$t('fbb.settlement.carrier_error',{defaultValue:'承运商异常'}); break;
                        case "OTHER_ERROR": errortype = this.$t('fbb.settlement.other_error',{defaultValue:'其他异常'}); break;
                    }
                    return <div>
                        <div>{errortype || '--'}</div>
                        <div>{row.errorMessage || '--'}</div>
                    </div>
                }
            },
            {
                title: this.$t('global.common.createdtime',{defaultValue:'创建时间'}),
                key: 'createdAt',
            },
            ];
        },

    },

};
